import React from 'react';

function SkeletonCard() {
  return (
    <div className="skeleton-card" aria-hidden="true">
      <div className="skeleton-poster skeleton-shimmer" />
      <div className="skeleton-body">
        <div className="skeleton-shimmer skeleton-title-line" />
        <div className="skeleton-shimmer skeleton-meta-line" />
        <div className="skeleton-shimmer skeleton-btn-line" />
      </div>
    </div>
  );
}

export default SkeletonCard;
